import {BigNumber} from 'ethers';

const toBN = (n: number): BigNumber => BigNumber.from(n);

export const SENTRY_DSN = "https://eadd33edce4a049051ae84f2cd9d4e2c@o4511474026414080.ingest.de.sentry.io/4511474034802768";

export const DECIMALS = 18; //18 decimal places after floating point
export const E18 = toBN(10).pow(toBN(DECIMALS));
export const CONFIRMATIONS_NUM = 1;
export const CONFIRMATIONS_TIMEOUT = 60;
